import React, { useState } from "react";
import styled from "styled-components";
import { COUNTRY } from "./CountryPicker";
import loadable from "@loadable/component";

const PhoneCountryPicker = loadable(() => import("./PhoneCountryPicker"));

const Form = styled.form`
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
`;

const InputBar = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 9px;
  box-shadow: 0 6px 32px 0 rgba(60, 60, 90, 0.13);
  padding: 6px 8px 6px 18px;
  width: 100%;
  position: relative;
`;

const StyledInput = styled.input`
  flex: 1 1;
  border: none;
  background: transparent;
  font-size: 17px;
  font-family: 'Poppins', sans-serif;
  color: #333;
  padding: 12px 0;
  outline: none;

  &::placeholder {
    color: #b0b3bb;
    opacity: 1;
    font-weight: 400;
    font-size: 15px;
  }
`;

const CTAButton = styled.button`
  background: #DC4AE1;
  color: #fff;
  border: none;
  border-radius: 9px;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 16px;
  padding: 12px 28px;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0 2px 16px 0 rgba(60, 60, 90, 0.13);
  cursor: pointer;
  transition: background 0.18s;

  &:hover {
    background: #9a41a7;
    box-shadow: 0 2px 10px 0 rgba(60, 60, 90, 0.4);
  }

  @media (max-width: 768px) {
    padding: 12px 13px;
  
  }
`;

const CountryPickerWrapper = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;
`;



const DisclaimerText = styled.div`
  max-width: 600px;
  color: #000;
  font-size: 12px;
  text-align: left;
  justify-content: flex-start;
  margin-top: 20px;
  
  a {
    color: #DC4AE1;
    text-decoration: underline;
  }
`;

const NewLoginInput = ({
  setShowModal,
  activeCountry,
  setActiveCountry,
  location,
}) => {
  const [userAccount, setUserAccount] = useState("");
  const letterExp = /[a-zA-Z]/g;
  const emailExp =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const isPhoneNumber = !letterExp.test(userAccount);
  const isEmail = emailExp.test(userAccount);
  const [isPopoverOpen, setPopover] = useState(false);

  // Support for extrParameters and pageSlug
  const params = new URLSearchParams(location?.search || "");
  let arr = Array.from(params.entries());
  const extrParameters = arr.length > 1 ? arr[1][1].replace("?", "&") : "";
  const landingPages = [
    "cancel",
    "hidden-money",
    "spam-calls",
    "free-trial-card"
  ];
  const pageSlug = location?.pathname?.replace(/\//g, "").trim() || "";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!userAccount) {
      window.location.replace('https://donotpay.com/login?ref=home');
      return;
    }
    let redirectUrl = "";
    if (isPhoneNumber) {
      redirectUrl = `https://donotpay.com/login?phone=${encodeURIComponent(
        userAccount
      )}&country=${encodeURIComponent(
        activeCountry.toLowerCase()
      )}${extrParameters}`;
      if (landingPages.indexOf(pageSlug) >= 0) {
        redirectUrl += `&ref=${pageSlug}`;
      }
    } else {
      redirectUrl = `https://donotpay.com/login?email=${encodeURIComponent(
        userAccount
      )}${extrParameters}`;
      if (landingPages.indexOf(pageSlug) >= 0) {
        redirectUrl += `&ref=${pageSlug}`;
      }
    }
    window.location.replace(redirectUrl);
  };

  return (
    <Form onSubmit={handleSubmit} autoComplete="off">
      <InputBar>
        {isPhoneNumber &&
          activeCountry &&
          COUNTRY[activeCountry.toLowerCase()] &&
          !userAccount.includes(COUNTRY[activeCountry.toLowerCase()].code) &&
          userAccount.length >= COUNTRY[activeCountry.toLowerCase()].code.length && (
            <CountryPickerWrapper>
              <PhoneCountryPicker
                setActiveCountry={setActiveCountry}
                activeCountry={activeCountry}
                isPopoverOpen={isPopoverOpen}
                setPopover={setPopover}
                setShowModal={setShowModal}
              />
            </CountryPickerWrapper>
          )}
        <StyledInput
          type="text"
          placeholder="Email or phone number"
          value={userAccount}
          onChange={e => {
            if (
              isPhoneNumber &&
              e.target.value.length >
              COUNTRY[activeCountry.toLowerCase()].code.length + 1 &&
              e.target.value.includes(
                COUNTRY[activeCountry.toLowerCase()].code
              )
            ) {
              setUserAccount(
                e.target.value
                  .toLowerCase()
                  .replace(/\s/g, "")
                  .replace(COUNTRY[activeCountry.toLowerCase()].code, "")
              );
            } else {
              setUserAccount(e.target.value.toLowerCase().replace(/\s/g, ""));
            }
          }}
        />
        <CTAButton type="submit">Start Now</CTAButton>
      </InputBar>

      <DisclaimerText style={{ marginTop: "20px" }}>
        By signing up or signing in, you are agreeing to{" "}
        <a href="https://donotpay.com/learn/terms-of-service/">
          DoNotPay's Terms and Conditions
        </a>{" "}
        and{" "}
        <a href="https://donotpay.com/learn/privacy-policy/">
          Privacy Policy
        </a>{" "}
        and consent to receive communications using the contact details provided.
        These terms include a binding arbitration clause.
        DoNotPay is not a law firm and does not provide legal advice.
        DoNotPay provides a platform for legal information and self-help.
      </DisclaimerText>
    </Form>
  );
};

export default NewLoginInput;